
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.625 12C23.625 5.625 18.375.375 12 .375 5.578.375.375 5.625.375 12c0 6.422 5.203 11.625 11.625 11.625 6.375 0 11.625-5.203 11.625-11.625zm-12.984 6.188c-.282.28-.797.28-1.079 0l-4.874-4.875c-.282-.282-.282-.797 0-1.079l1.078-1.03a.663.663 0 011.03 0l3.329 3.28 7.031-7.03a.663.663 0 011.032 0l1.078 1.03c.28.282.28.797 0 1.079l-8.625 8.624z","fill":"currentColor"}})])
          )
        }
      }
    